import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import Master from "screen/Master";
import styles from "../AddSchedule.module.scss";
import { useHistory } from "react-router-dom";
import {
  getRequest as getEnterprise,
  deleteRequest as deleteSchedule,
} from "services/axiosBaseClient";
import NewTableAndSearchMasterFilter from "../common/NewTableAndSearchMasterFilter";
import notificationService from "services/notification.service";
import ConfirmationDialog from "components/common/ConfirmDialog";

var tempHeaderFilterQery;
function ScheduleView(props) {
  const history = useHistory();
  const [invoiceData, setInvoiceData] = useState([]);
  const [swapStationCount, setSwapStationCount] = useState("");
  const [offset, setOffset] = useState(0);

  var pageSize = 10;
  var pageNumber = 0;
  var pagingString = "limit=" + pageSize + "&offset=" + pageNumber;
  var tempTigger;

  useEffect(() => {
    tempTigger = !history?.location?.state?.compomentRenderType
      ? "init"
      : history?.location?.state?.compomentRenderType === "amhitted"
      ? "amhitted"
      : history?.location?.state?.compomentRenderType === "view"
      ? "view"
      : "init";
  }, [
    history?.location?.state?.compomentRenderType ||
      props.history?.location?.state?.compomentRenderType,
  ]);

  const pageLimitHandle = (offsett, limit, tigger, tempHeaderFilter) => {
    tempTigger = tigger;
    const testCount = tigger == "amhitted" ? 1 : offsett;
    pageNumber = offsett;
    pageSize = limit;
    searchSwapStationByFilter(tempHeaderFilter);
  };

  const paginationCountHanlde = (offsett, limit, tigger, tempHeaderFilter) => {
    tempTigger = tigger;
    const testCount = tigger == "amhitted" ? 1 : offsett;
    // pageNumber = offsett;
    pageNumber = offsett;
    pageSize = limit;
    // searchSwapStationByFilter(tempHeaderFilter);
  };

  const updateScheduleHandle = (data) => {
    history.push("/Schedule/UpdateSchedule/" + data?.row?.original?.id);
  };

  const deleteScheduleHandle = (scheduleId) => {
    deleteSchedule("deleteSchedule?scheduleId=" + scheduleId)
      .then((res) => {
        if (res && res?.data) {
          searchSwapStationByFilter(localStorage.getItem("paging"));
          notificationService.showNonBlacklisted(
            res?.config?.url,
            res?.data?.message
          );
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Zone",
        accessor: "zoneName",
      },
      {
        Header: "Site",
        accessor: "siteName",
      },
      {
        Header: "Schedule Name",
        accessor: "name",
      },
      {
        Header: "Slot",
        accessor: "startTime",
        Cell: (row) => {
          const scheduleSlot =
            row?.row?.original?.startTime + " - " + row.row.original?.endTime;
          return <span>{scheduleSlot}</span>;
        },
      },
      {
        Header: "Day",
        accessor: "day",
        Cell: (row) => {
          const scheduleDay = makeDays(row?.row?.original?.days);
          return <span>{scheduleDay}</span>;
        },
      },
      {
        Header: "Start Date",
        accessor: "startDate",
      },
      {
        Header: "End Date",
        accessor: "endDate",
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: (row) => {
          return (
            <>
              <img
                src={require("assets/pencil.png").default}
                style={{ cursor: "pointer" }}
                onClick={() => updateScheduleHandle(row)}
              />
              <ConfirmationDialog
                data={row?.row?.original?.id}
                handleStatus={(data) => {
                  deleteScheduleHandle(data);
                }}
                assets={"Schedule"}
                name={row?.row?.original.name}
              />
            </>
          );
        },
      },
    ],
    [invoiceData]
  );

  const getTime = (value) => {
    return new Date(value).toLocaleTimeString("en-US");
  };

  function removeSpace(str) {
    return str.split(" ").join("");
  }

  function makeDays(str) {
    const string = removeSpace(str);
    const firstLetters = string
      .split(",")
      .map((string) => string.slice(0, 3))
      .join(" | ");
    return firstLetters.toUpperCase();
  }

  const searchSwapStationByFilter = (headerFilterQuery) => {
    tempHeaderFilterQery = headerFilterQuery;
    const pagingStringInit = "offset=" + 0 + "&limit=" + 10;
    pagingString = "offset=" + pageNumber + "&limit=" + pageSize;
    const queryParam =
      tempTigger == "amhitted"
        ? pagingStringInit
        : typeof tempTigger === "undefined"
        ? pagingStringInit
        : pagingString;

    // localStorage.setItem("pagingString", pagingString);

    getEnterprise("getAllSchedule?" + tempHeaderFilterQery)
      .then((res) => {
        if (res && res?.data) {
          setInvoiceData(res?.data?.schedules);
          setSwapStationCount(res?.data?.count);
        } else {
          setInvoiceData([]);
          setSwapStationCount(0);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
    // }
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <>
      <div id="ScheduleList_block" className={cn(styles.flex_item1)}>
        <div id="ScheduleList_layout" className={cn(styles.flex1)}>
          <h2 id="ScheduleList_Heading" className={cn(styles.medium_title, styles.medium_title_layout)}>
            {"Schedule"}
          </h2>

          <NewTableAndSearchMasterFilter
            searchOpts={{
              // placeholder: "Search by invoice no",
              filter: false,
              onFilterSearch: searchSwapStationByFilter,
              screentype: "swapping",
              buttonText: "schedule",
            }}
            headerFilter={props.headerFilter}
            columns={columns}
            paginationDoubleScreen={true}
            // data={swappedSessionData}
            data={invoiceData}
            swapStationCount={swapStationCount}
            offset={offset}
            tigger={
              history?.location?.state?.compomentRenderType
                ? history?.location?.state?.compomentRenderType
                : tempTigger
            }
            pageNumber={pageNumber}
            paginationCountHanlde={paginationCountHanlde}
            pageLimitHandle={pageLimitHandle}
          />
        </div>
        <div></div>
      </div>
    </>
  );
}

export default function Schedule(props) {
  const [headerFilter, setHeaderFilter] = useState(true);

  return (
    <>
      <Master
        opts={props}
        screen={ScheduleView}
        showStatus={false}
        headerFilter={headerFilter}
        setHeaderFilter={setHeaderFilter}
      />
    </>
  );
}

Schedule.inStorybook = true;
